function _splitSections(text) {
  const tokens = text.split(/\s+/);
  const segments = [];
  let cur = null;

  const isHeaderWord = (w) => {
    const letters = w.replace(/[^A-Za-záéíóúüñÁÉÍÓÚÜÑ]/g, "");
    return letters.length >= 3 && letters === letters.toUpperCase();
  };
  const isConnector = (w) => {
    const letters = w.replace(/[^A-Za-záéíóúüñÁÉÍÓÚÜÑ]/g, "");
    return /^[\/&]$/.test(w) || (letters.length > 0 && letters.length <= 2 && letters === letters.toUpperCase());
  };

  for (let i = 0; i < tokens.length; i++) {
    const w = tokens[i];
    if (isHeaderWord(w)) {
      if (!cur || cur.type !== "header") { cur = { type: "header", words: [] }; segments.push(cur); }
      cur.words.push(w);
    } else if (isConnector(w) && cur?.type === "header" && i + 1 < tokens.length && isHeaderWord(tokens[i + 1])) {
      cur.words.push(w);
    } else {
      if (!cur || cur.type !== "text") { cur = { type: "text", words: [] }; segments.push(cur); }
      cur.words.push(w);
    }
  }
  return segments.map(s => s.words.join(" ")).join("\n");
}

export function renderDescription(text, isDark) {
  if (!text) return null;
  const bodyColor = isDark ? "rgba(255,255,255,0.75)" : "#4b5563";
  const headColor = isDark ? "rgba(255,255,255,0.95)" : "#111827";

  let src = text;
  if (!src.includes("\n")) {
    src = _splitSections(src);
  }

  const lines = src.split("\n").map(l => l.trim()).filter(Boolean);
  const blocks = [];
  let listItems = null;

  const flushList = () => {
    if (listItems) { blocks.push({ type: "list", items: listItems }); listItems = null; }
  };

  for (const line of lines) {
    const stripped = line.replace(/[^A-Za-záéíóúüñÁÉÍÓÚÜÑ]/g, "");
    const isAllCaps = stripped.length >= 3 && stripped === stripped.toUpperCase();
    const isSubHeader = /^[^:]{2,40}:$/.test(line);
    const isBullet = /^[•\-\*]\s/.test(line) || /^\d+\.\s/.test(line);

    if (isBullet) {
      if (!listItems) { listItems = []; }
      listItems.push(line.replace(/^([•\-\*]|\d+\.)\s+/, ""));
    } else {
      flushList();
      if (isAllCaps || isSubHeader) {
        blocks.push({ type: "header", text: line });
      } else {
        blocks.push({ type: "text", text: line });
      }
    }
  }
  flushList();

  return (
    <div className="space-y-1 text-sm" style={{ color: bodyColor }} data-testid="product-description">
      {blocks.map((block, i) => {
        if (block.type === "header") {
          return (
            <p key={i} className="font-bold text-xs uppercase tracking-wide pt-2 pb-0.5 border-b"
              style={{ color: headColor, borderColor: isDark ? "rgba(255,255,255,0.15)" : "#e5e7eb" }}>
              {block.text}
            </p>
          );
        }
        if (block.type === "list") {
          return (
            <ul key={i} className="space-y-0.5 pl-1">
              {block.items.map((item, j) => (
                <li key={j} className="flex gap-2 leading-snug">
                  <span className="mt-0.5 shrink-0" style={{ color: isDark ? "rgba(255,255,255,0.4)" : "#9ca3af" }}>•</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          );
        }
        return <p key={i} className="leading-relaxed">{block.text}</p>;
      })}
    </div>
  );
}
